// Date and time format constants
export const DATABASE_DATE_FORMAT = 'DD-MM-YYYY';
export const DATABASE_TIME_FORMAT = 'HH:mm';
export const DATABASE_DATE_TIME_FORMAT = `${DATABASE_DATE_FORMAT} ${DATABASE_TIME_FORMAT}`;

// Duration constants
export const FRACTION_DURATION = 30;

// Replacement type options
export const REPLACEMENT_TYPES = [
  {
    label: "Completa",
    value: "complete",
  }, 
  {
    label: "Por fracciones",
    value: "by-parts"
  }
];

// Replacement position options
export const REPLACEMENT_POSITION_OPTIONS = [
  {
    label: "Agregar al inicio",
    value: "addBefore"
  }, 
  {
    label: "Agregar al final",
    value: "addAfter"
  }
];

// Position values
export const POSITION_VALUES = {
  ADD_BEFORE: 'addBefore',
  ADD_AFTER: 'addAfter',
  NEW_CLASS: 'newClass',
};

// Replacement type values
export const REPLACEMENT_TYPE_VALUES = {
  COMPLETE: 'complete',
  BY_PARTS: 'by-parts',
};

// Time picker configuration
export const TIME_PICKER_CONFIG = {
  MINUTE_STEP: 15,
  USE_12_HOURS: true,
  FORMAT: "h:mm a",
  POPUP_CLASS_NAME: 'group-schedule-timepicker',
};

// Date picker configuration
export const DATE_PICKER_CONFIG = {
  POPUP_CLASS_NAME: "reposition-datepicker",
};

// Input number configuration
export const INPUT_NUMBER_CONFIG = {
  MIN: 1,
  PLACEHOLDER: "Selecciona las partes a usar",
};

// Form validation messages
export const VALIDATION_MESSAGES = {
  REPLACEMENT_TYPE_REQUIRED: 'Por favor selecciona un tipo de reposición',
  PARTS_PER_CLASS_REQUIRED: 'Por favor selecciona cuántas partes usar por clase',
  PARTS_PER_CLASS_RANGE: (max) => `Debe ser entre 1 y ${max} partes`,
  REPLACEMENT_POSITION_REQUIRED: 'Por favor selecciona una opción de reposición',
  NEW_CLASS_TIME_REQUIRED: 'Por favor selecciona un horario para la clase',
  NEW_CLASS_TIME_ALREADY_EXISTS: 'Ya existe una clase programada en este horario',
  TIME_REQUIRED: 'Ingresa un rango de horas válido',
  CLASS_SELECTION_REQUIRED: 'Por favor selecciona una clase',
};

// CSS class names
export const CSS_CLASSES = {
  DAY_HAS_CLASSES: 'day-has-classes',
  IS_CANCELLED_DATE: 'is-cancelled-date',
  CLASS_MODAL: 'class-modal',
  CONTAINER_FORM: 'container-form',
};

// Text constants
export const TEXT = {
  MODAL_TITLE: '¿Deseas reagendar esta clase?',
  GROUP_LABEL: 'Grupo:',
  PREVIOUS_SCHEDULE_LABEL: 'Horario anterior:',
  REPLACEMENT_TYPE_LABEL: 'Tipo de reposición',
  TO_SCHEDULE_LABEL: 'Por agendar:',
  PARTS_PER_CLASS_LABEL: 'Partes por clase',
  FRACTIONS_LABEL: (count) => `${count} ${count > 1 ? 'fracciones' : 'fracción'} de ${FRACTION_DURATION} minutos`,
  SCHEDULE_LABEL: 'Horario',
  REPOSITION_DATE_LABEL: (index) => `Fecha de reposición ${index + 1}`,
  REPOSITION_DURATION_LABEL: (duration) => `Reposición de ${duration} minutos`,
  SCHEDULED_CLASSES_LABEL: (date) => `Clases programadas para el ${date}:`,
  NO_CLASSES_MESSAGE: (date) => `No hay clases programadas para el ${date}`,
  SCHEDULE_TIME_LABEL: 'Horario:',
  SELECT_CLASS_LABEL: 'Seleccionar clase',
  CANCEL_BUTTON_TEXT: 'Regresar',
  SAVE_BUTTON_TEXT: 'Continuar',
};
